import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute, Second } from '@nu-art/ts-common';
import { ApiDef_RuntimeSmartNote } from '../smart-note/index.js';
import { ApiDef_ProviderChat } from '../provider-chat/api-def.js';
//####################### Advisor utils Apis #######################
export const ApiDef_AdvisorUtils = {
    resetAdvisorState: { method: HttpMethod.GET, path: '/advisor-interface/reset-encounter', timeout: 3 * Minute },
    launchKickstart: {
        method: HttpMethod.POST,
        path: '/encounter-manager/launch-kickstart',
        timeout: 3 * Minute
    },
    updateEncounterStatus: {
        method: HttpMethod.POST,
        path: '/advisor-interface/update-encounter-status',
        timeout: Minute
    },
    submitSurvey: {
        method: HttpMethod.POST,
        path: '/survey/submit-survey',
        timeout: 3 * Minute
    },
    getEMQuaiEhrInstances: {
        method: HttpMethod.GET,
        path: '/quai-emr/get-quai-ehr-instances',
        timeout: Minute
    },
    getEMQuaiEnvironments: {
        method: HttpMethod.GET,
        path: '/quai-emr/get-quai-environments',
        timeout: Minute
    },
    getEMQuaiFacilities: {
        method: HttpMethod.GET,
        path: '/quai-emr/get-quai-facilities',
        timeout: Minute
    },
    setPractitionerConfig: {
        method: HttpMethod.POST,
        path: '/advisor-interface/set-ui-state-for-practitioner',
        timeout: Minute,
    },
    recordPractitionerView: {
        method: HttpMethod.POST,
        path: '/advisor-interface/record-practitioner-view',
        timeout: Minute,
    }
};
//####################### Protocols Apis #######################
export const ApiDef_Protocols = {
    launchProtocol: { method: HttpMethod.GET, path: '/encounter-manager/launch-pathway', timeout: Minute },
    switchProtocolConsiderationGroup: {
        method: HttpMethod.GET,
        path: '/encounter-manager/switch-protocol-consideration-group',
        timeout: Minute
    },
    /**
     * @deprecated Feeds only the manual "Add Protocol" panel. The EM artifact build now
     * enforces pathway integrity, so the backend's `failed` list is always empty and
     * `succeeded` is just the config's pathways — the failed/unavailable distinction no
     * longer carries meaning. To be removed once Add-Protocol is re-sourced from the
     * config's pathways directly.
     */
    getAvailableProtocols: {
        method: HttpMethod.GET,
        path: '/encounter-manager/get-failed-succeeded-pathways',
        timeout: Minute
    },
};
//####################### Orders Apis #######################
export const ApiDef_Orders = {
    resolveOrder: { method: HttpMethod.POST, path: '/encounter-manager/resolve-runtime-order', timeout: Minute },
    completeOrders: { method: HttpMethod.POST, path: '/encounter-manager/complete-runtime-orders', timeout: Minute },
    createRunTimeOrders: { method: HttpMethod.POST, path: '/encounter-manager/create-runtime-orders', timeout: 3 * Minute },
    acceptRuntimeOrders: { method: HttpMethod.POST, path: '/encounter-manager/accept-runtime-orders', timeout: 3 * Minute },
    rejectRuntimeOrders: { method: HttpMethod.POST, path: '/encounter-manager/reject-runtime-orders', timeout: Minute },
};
//####################### Encounter Apis #######################
export const ApiDef_Encounter = {
    clearEncounterState: {
        method: HttpMethod.GET,
        path: '/advisor-interface/clear-encounter',
        timeout: 3 * Minute
    },
    endEncounter: { method: HttpMethod.POST, path: '/advisor-interface/process-disposition', timeout: Minute },
    updateEncounter: { method: HttpMethod.POST, path: '/encounter-manager/update-encounter', timeout: 3 * Minute }
};
//####################### Calculator Apis #######################
export const ApiDef_Calculator = {
    getExpressionNeededVariables: {
        method: HttpMethod.POST,
        path: '/encounter-manager/get-needed-variables-for-expression',
        timeout: Minute
    },
    simulateExpressionCalculation: {
        method: HttpMethod.POST,
        path: '/encounter-manager/simulate-expressions-calculation',
        timeout: Minute
    },
};
//####################### Navigator Apis #######################
export const ApiDef_Navigator = {
    manualNavigateOnTransition: {
        method: HttpMethod.POST,
        path: '/encounter-manager/manually-navigate-on-transition',
        timeout: Minute
    },
    simulateNavigation: {
        method: HttpMethod.POST,
        path: '/encounter-manager/simulate-navigation',
        timeout: Minute
    },
    goToState: {
        method: HttpMethod.POST,
        path: '/encounter-manager/go-to-state',
        timeout: Minute
    },
};
//####################### Debug Apis #######################
export const ApiDef_Debug = {
    getFindingsDump: {
        method: HttpMethod.GET,
        path: '/debug/export-findings',
        timeout: Minute
    },
    getEncounterDataExport: {
        method: HttpMethod.GET,
        path: '/debug/export-encounter-data',
        timeout: Minute
    },
    submitSupportTicket: {
        method: HttpMethod.POST,
        path: '/customer-ticket/create-customer-ticket',
        timeout: Minute
    },
    isEMAlive: { method: HttpMethod.GET, path: '/encounter-manager/is_alive', timeout: 20 * Second }
};
//####################### Sandbox Apis #######################
export const ApiDef_Sandbox = {
    getNlpSandboxVariables: {
        method: HttpMethod.POST,
        path: '', // no clue what this should be
        timeout: Minute
    },
    getFHIRQuerySandbox: {
        method: HttpMethod.POST,
        path: '/encounter-manager/fhir-sandbox',
        timeout: Minute
    },
    fhirSandbox: {
        method: HttpMethod.POST,
        path: '/advisor-interface/fhir-sandbox',
        timeout: Minute
    },
};
//####################### SmartLogs Apis #######################
export const ApiDef_RuntimeSmartLog = {
    createProvidersNote: { method: HttpMethod.POST, path: '/encounter-manager/create-smart-log', timeout: 3 * Minute },
    updateProvidersNote: {
        method: HttpMethod.POST,
        path: '/encounter-manager/update-providers-note',
        timeout: 3 * Minute
    },
};
//####################### SmartOnFhir Apis #######################
export const ApiDef_SmartOnFHIR = {
    temp_deployIntegration: {
        method: HttpMethod.POST,
        path: '/advisor-interface/launch-mayo-deploy',
        timeout: 3 * Minute
    },
    smartOnFhir: { method: HttpMethod.GET, path: '/advisor-interface/launch-smart', timeout: 3 * Minute },
    getSandboxLaunchUrl: { method: HttpMethod.POST, path: '/quai-emr/get-launch-url', timeout: Minute },
};
//####################### APIDef - Launch #######################
const ApiDef_Advisor_Launch = {
    bootstrap: { method: HttpMethod.GET, path: '/advisor-interface/launch-bootstrap-session' },
};
//####################### Advisor Apis #######################
export const ApiDef_Advisor = {
    vv1: {
        advisorUtils: ApiDef_AdvisorUtils,
        protocols: ApiDef_Protocols,
        orders: ApiDef_Orders,
        encounter: ApiDef_Encounter,
        calculator: ApiDef_Calculator,
        navigator: ApiDef_Navigator,
        debug: ApiDef_Debug,
        sandbox: ApiDef_Sandbox,
        smartNote: ApiDef_RuntimeSmartNote,
        smartLog: ApiDef_RuntimeSmartLog,
        smartOnFHIR: ApiDef_SmartOnFHIR,
        chatting: ApiDef_ProviderChat,
        launch: ApiDef_Advisor_Launch,
    },
};
//# sourceMappingURL=api-defs.js.map